// Курируемый whitelist иконок для «Типов запусков». Lucide содержит ~1500
// иконок; для picker'а выбраны ~60 наиболее осмысленных под контекст запуска/
// маркетинга/контента. Значение в `name` — slug для lucide-react (kebab-case
// → PascalCase ресолвится в DynamicIcon).
//
// При добавлении новой иконки: убедиться, что соответствующий компонент есть
// в lucide-react (https://lucide.dev), обновить DynamicIcon whitelist.

export interface LaunchTypeIcon {
  name: string; // slug
  label: string; // человеческое имя для picker'а
}

export const LAUNCH_TYPE_ICONS: LaunchTypeIcon[] = [
  // broadcast / live
  { name: "radio", label: "Радио / эфир" },
  { name: "mic", label: "Микрофон" },
  { name: "megaphone", label: "Рупор" },
  { name: "video", label: "Видео" },
  { name: "podcast", label: "Подкаст" },
  // education / course
  { name: "graduation-cap", label: "Выпускник" },
  { name: "book-open", label: "Книга" },
  { name: "layers", label: "Поток" },
  { name: "library", label: "Библиотека" },
  { name: "school", label: "Школа" },
  // marketing / funnel
  { name: "rocket", label: "Ракета" },
  { name: "zap", label: "Молния" },
  { name: "flame", label: "Огонь" },
  { name: "trending-up", label: "Рост" },
  { name: "target", label: "Цель" },
  { name: "funnel", label: "Воронка" },
  { name: "gift", label: "Подарок" },
  { name: "ticket", label: "Билет" },
  { name: "tag", label: "Тег" },
  { name: "percent", label: "Скидка" },
  // commerce
  { name: "shopping-bag", label: "Покупка" },
  { name: "shopping-cart", label: "Корзина" },
  { name: "credit-card", label: "Карта" },
  { name: "coins", label: "Монеты" },
  { name: "banknote", label: "Банкнота" },
  { name: "wallet", label: "Кошелёк" },
  // comms / email
  { name: "mail", label: "Почта" },
  { name: "send", label: "Отправить" },
  { name: "message-square", label: "Сообщение" },
  { name: "bell", label: "Уведомление" },
  { name: "phone", label: "Телефон" },
  // community / audience
  { name: "users", label: "Люди" },
  { name: "user-plus", label: "Новый участник" },
  { name: "handshake", label: "Рукопожатие" },
  { name: "heart", label: "Сердце" },
  { name: "star", label: "Звезда" },
  // content
  { name: "image", label: "Изображение" },
  { name: "film", label: "Фильм" },
  { name: "music", label: "Музыка" },
  { name: "edit-3", label: "Редактирование" },
  { name: "pen-tool", label: "Ручка" },
  { name: "file-text", label: "Документ" },
  // trophy / result
  { name: "trophy", label: "Кубок" },
  { name: "award", label: "Награда" },
  { name: "medal", label: "Медаль" },
  { name: "crown", label: "Корона" },
  { name: "sparkles", label: "Блёстки" },
  // time / deadline
  { name: "calendar", label: "Календарь" },
  { name: "calendar-days", label: "Календарь (дни)" },
  { name: "clock", label: "Часы" },
  { name: "timer", label: "Таймер" },
  { name: "hourglass", label: "Песочные часы" },
  // ideas / setup
  { name: "lightbulb", label: "Идея" },
  { name: "sprout", label: "Росток" },
  { name: "wand", label: "Волшебная палочка" },
  { name: "compass", label: "Компас" },
  { name: "map", label: "Карта" },
  { name: "flag", label: "Флаг" },
  // control / misc
  { name: "sliders", label: "Слайдеры" },
  { name: "layout-grid", label: "Сетка" },
  { name: "package", label: "Коробка" },
  { name: "plus", label: "Плюс" },
];

export const DEFAULT_LAUNCH_TYPE_ICON = "sparkles";

export function isKnownLaunchTypeIcon(name: string): boolean {
  return LAUNCH_TYPE_ICONS.some((i) => i.name === name);
}
